import React from 'react';
import Chart from "react-apexcharts";
import global from '../../../common/utility/global';

export default function GraficoProductoSoles(props) {
    
    const options = {
      series: [{
        name: "Total Vendido (S/)",
        data: props.series
      }],
      title: {
        text: 'Ranking Producto - Total Ventas'
      },
      chart: {
        type: 'bar',
        height: 350
      },
      plotOptions: {
        bar: {
          horizontal: true,
        }
      },
      dataLabels: {
          formatter: function (val) {
            
            return global.decimalFormat(val.toFixed(2))
          }
      },
      xaxis: {
        categories: props.productos,
        labels: {
          formatter: function (val) {
            
            return global.decimalFormat(val.toFixed(2))
          }
        }
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return global.decimalFormat(val.toFixed(2))
          }
        }
      }
    };

    
    return (
      <div id="chart">
        <Chart options={options} series={options.series} type="bar" height={350} />
      </div>
    );
}